var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "889.879 532.659 321.471 118.726",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsvectornator: "http://vectornator.io",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud3"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 118.726,
    width: 321.471,
    x: 889.879,
    y: 532.659
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud3)",
    id: "Layer",
    vectornatorlayername: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1211.35 554.202L1211.35 554.202C1211.35 542.304 1201.7 532.659 1189.81 532.659L964.914 532.659C953.016 532.659 943.371 542.304 943.371 554.202L943.371 554.202C943.371 566.1 953.016 575.745 964.914 575.745L1016.84 575.745C1025.3 575.745 1032.16 582.602 1032.16 591.06L1032.16 591.06C1032.16 599.518 1025.3 606.375 1016.84 606.375L912.384 606.375C899.955 606.375 889.879 616.451 889.879 628.88L889.879 628.88C889.879 641.309 899.955 651.385 912.384 651.385L1157.63 651.385C1170.05 651.385 1180.13 641.309 1180.13 628.88L1180.13 627.081C1180.13 615.645 1170.86 606.374 1159.42 606.374L1159.42 606.374C1150.97 606.374 1144.11 599.517 1144.11 591.059L1144.11 591.059C1144.11 582.601 1150.97 575.744 1159.42 575.744L1189.81 575.744C1201.7 575.746 1211.35 566.1 1211.35 554.202Z",
    fill: "#a9b3c1",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud3);
export default __webpack_public_path__ + "static/media/Cloud3.695ad7349b4a29ca6e9ac6f8e2167595.svg";
export { ForwardRef as ReactComponent };